module.exports = __webpack_public_path__ + "static/media/55_000014.615a2843.jpg";